import { useMutation } from '@tanstack/react-query'

import {
  postFileUpload,
  postMultiPartFileUpload,
} from '~/features/file-upload/apis/fileUpload'

export const useFileUpload = () => {
  return useMutation({
    mutationFn: (file: File) => postFileUpload(file),
  })
}

export const useMultiPartFileUpload = () => {
  return useMutation({
    mutationFn: (file: File) => postMultiPartFileUpload(file),
  })
}
